import React from 'react';
import { Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from '../../context/ThemeContext';
import styles from './MainContent.module.scss';
import Dashboard from '../Dashboard/Dashboard';
import RightPanel from '../RightPanel/RightPanel';

const MainContent = () => {
  const { isDarkMode } = useTheme();

  const muiTheme = createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: '#e36250 !important',
      },
      secondary: {
        main: '#8b5cf6',
      },
    },
  });

  return (
    <ThemeProvider theme={muiTheme}>
      <Box className={styles.mainContent}>
        <Box className={`${styles.mainScroll} scrollable-no-scrollbar`}>
          <Dashboard />
        </Box>
        <RightPanel />
      </Box>
    </ThemeProvider>
  );
};

export default MainContent;
